import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateCoupon = ({ show, onClose, selectedId, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Input datas
    const [coupon_name, setname] = useState('');
    const [couponType, setCouponType] = useState(null);
    const [couponValue, setCouponValue] = useState('');
    const [couponCode, setCouponCode] = useState("");
    const [couponFor, setCouponfor] = useState(0);
    const [endDate, setEndDate] = useState(null);
    const [endDatedisp, setEndDateDisp] = useState(null);
    const [customCode, setCustomCode] = useState(false);
    
    
    useEffect(() => {
        axios.get(`${baseURL}/coupon/${selectedId}`)
            .then(response => {
                const data = response.data.data;
                setCouponCode(data.coupon_code);
                setname(data.coupon_name);
                setCouponType(data.coupon_type); // dropdown
                if (parseFloat(data.coupon_value) % 1 === 0) {
                    setCouponValue(parseFloat(data.coupon_value).toFixed(0));
                } else {
                    setCouponValue(parseFloat(data.coupon_value).toFixed(2));
                }
                setCouponfor(data.coupon_for);
                setEndDate(data.enddate);
                setEndDateDisp(new Date(data.enddate).toLocaleDateString('en-GB').split('/').join('-'));
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    const handleStartDateChange = (date) => {
        setEndDateDisp(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            setEndDate(formattedDate);
        } else {
            setEndDate(null);
        }
    };

    const handleToggleCodeType = (type) => {
        setCustomCode(type === 'custom'); 
    };

    const generateCouponCode = () => {
        setCouponCode("GENERATED" + Math.floor(Math.random() * 10000));
        setCustomCode(false);
    };

    const coupon_type = [
        { value: 0, label: "Amount" },
        { value: 1, label: "Percentage" }
    ];
    const selectedCouponType = coupon_type.find(option => option.value === couponType);

    // format name
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    function formatCouponValue(value) {
        if (value === undefined || value === null || value === '') {
            return 0; // or handle required validation elsewhere
        }

        // Try to convert to a number
        let num = Number(value);

        if (isNaN(num)) {
            // If not a number, return null or handle error
            return 0;
        }

        // Check if number is decimal (has fractional part)
        if (!Number.isInteger(num)) {
            // Round to 2 decimal places
            num = Math.round(num * 100) / 100;
        } else {
            // It's an integer, just pass as is (or convert to int explicitly)
            num = parseInt(num, 10);
        }

        return num;
    }

    const [data_name, setData] = useState([]);
    const [all_coupon_code, setallcouponcode] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/coupon`)
            .then(response => {
            setData(response.data.data.filter(item => item.sno !== selectedId).map(mode => mode.coupon_name.toLowerCase()));
            setallcouponcode(response.data.data.filter(item => item.sno !== selectedId).map(code => code.coupon_code.toLowerCase()));
            })
            .catch(error => {
            console.log('There was an error fetching the data!', error);
            });
    }, [])
    
    // on submit
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!coupon_name.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (data_name.includes(coupon_name.trim().toLowerCase())) {
            newErrors.name = "This Name Already Exists.";
        }
        
        if (couponType === null) {
            newErrors.typ = "This Field is Required.";
        }

        if (!couponValue) {
            newErrors.typ = "This Field is Required.";
        }

        if (!couponCode) {
            newErrors.code = "This Field is Required.";
        }

        if (all_coupon_code.includes(couponCode.trim().toLocaleLowerCase())){
            newErrors.code = "The Coupon Code Already Exist.";
        }
        
        if (!endDate) {
            newErrors.endDate = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const formattedValue = formatCouponValue(couponValue);
        let post = {
            coupon_name: coupon_name,
            coupon_value: formattedValue,
            coupon_type: couponType,
            coupon_code: couponCode,
            coupon_for: couponFor,
            startdate: new Date().toISOString().slice(0, 10),
            enddate: endDate
        }

        axios.put(`${baseURL}/coupon/${selectedId}`, post)
            .then(response => {
                onClose();
                refresh();
                toast.success("Coupon Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Coupon Updation Failed");
            });
    };



    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Coupon</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">

                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Coupon Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Coupon Name" 
                                    maxLength={100}
                                    value={coupon_name} 
                                    onChange={(e) => {
                                        const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        setname(formatName(onlyAlphabets));
                                    }}
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Coupon Value<span className="required">*</span></label>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <input type="text" className="form-control" placeholder="Enter Coupon Value" 
                                            maxLength={10}
                                            value={couponValue} 
                                            onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/[^0-9.]/g, '');
                                                setCouponValue(onlyNums);
                                            }}
                                        />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Select
                                            value={selectedCouponType}
                                            onChange={(selectedOptions) => {
                                                setCouponType(selectedOptions.value);
                                            }}
                                            options={coupon_type}
                                            placeholder="Select Type"
                                        />
                                    </div>
                                    {errors.typ && <div className="text-danger fs-8 mt-1">{errors.typ}</div>}
                                </div>
                            </div>
                            {!customCode && (
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Coupon Code</label>
                                    <div className="form-control">{couponCode}</div> {/* Display generated code */}
                                </div>
                            )}
                            {customCode && (
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">
                                        Custom Code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Coupon Code"
                                        value={couponCode} // Bind input to state
                                        onChange={(e) => setCouponCode(e.target.value)} // Update couponCode state
                                    />
                                    <div className="text-danger fs-8 mt-1">{errors.code}</div>
                                </div>
                            )}
                            <div className='col-lg-6 mb-3 d-flex align-items-center justify-content-center gap-3'>
                                <Link type="submit" className="btn btn-sm btn-primary" onClick={generateCouponCode}>Generate Code</Link>
                                <Link type="submit" className="btn btn-sm btn-primary" onClick={() => handleToggleCodeType('custom')}>Custom Code</Link>
                            </div>

                            <div className="col-lg-6 mb-2">
                                <label className="text-black font-w500 fs-7">End Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        value={endDatedisp}
                                        onChange={(date) => {
                                            handleStartDateChange(date);
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={new Date().setHours(0,0,0)}
                                    />
                                </div>
                                {errors.endDate && <div className="text-danger fs-8 mt-1">{errors.endDate}</div>}
                            </div>
                            <div className='col-lg-6 mb-2'>
                                <label className="text-black font-w500 fs-7">Coupon Type <span className="required">*</span></label>
                                <div className='d-block'>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="product_type"
                                            value="option1"
                                            checked={couponFor === 0}
                                            onChange={() => setCouponfor(0)}
                                        />
                                        <label className="form-check-label fs-7">
                                            Welcome Offer
                                        </label>
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="product_type"
                                            value="option2"
                                            checked={couponFor === 1}
                                            onChange={() => setCouponfor(1)}
                                        />
                                        <label className="form-check-label fs-7">
                                            Recursion
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary" >Update Coupon<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default UpdateCoupon;
